module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editSurveyDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editSurveyForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.dialogTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordionEditSurvey",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyGeneral",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyGeneral",
      "aria-expanded": "true",
      "aria-controls": "collapseEditSurveyGeneral"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U0015))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseEditSurveyGeneral",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyGeneral"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0016) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyClientSelect",
      "placeholder": _vm.lang.U1000,
      "allowClear": true,
      "disabled": !_vm.dialogModeAdd && !_vm.copySurvey,
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.getSurveyGroupList()
      }
    },
    model: {
      value: (_vm.surveyData.ClientGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ClientGuid", $$v)
      },
      expression: "surveyData.ClientGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                          " + _vm._s(client.ClientName) + "\n                        ")])
  })], 2)], 1)]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "editSurveyImporterSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1075))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "editSurveyImporterSelect",
      "placeholder": _vm.lang.U1000,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        return _vm.getSurveyGroupList()
      }
    },
    model: {
      value: (_vm.surveyData.ImporterGuid),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ImporterGuid", $$v)
      },
      expression: "surveyData.ImporterGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                          " + _vm._s(importer.ImporterName) + "\n                        ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0017) + "*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle),
      expression: "surveyData.SurveyTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle",
      "name": "inputTitle",
      "required": ""
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateInput('inputTitle')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputTitle')),
      expression: "inputHasError('inputTitle')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.U0020))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle2"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle2),
      expression: "surveyData.SurveyTitle2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle2"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputTitle3"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0019))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyTitle3),
      expression: "surveyData.SurveyTitle3"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputTitle3"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyTitle3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyTitle3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "selectSurveySkillLevel"
    }
  }, [_vm._v(_vm._s(_vm.lang.U0040))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.surveyData.SurveySkillLevel),
      expression: "surveyData.SurveySkillLevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "selectSurveySkillLevel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.$set(_vm.surveyData, "SurveySkillLevel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((5), function(i) {
    return _c('option', {
      key: i
    }, [_vm._v(_vm._s(i))])
  }), 0)]), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "target": "selectSurveySkillLevel",
      "delay": _vm.globals.tooltipDelay,
      "placement": "right",
      "boundary": "viewport"
    }
  }, [_vm._v("\n                      1 → " + _vm._s(_vm.lang.U0041) + "\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("...\n                      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                      5 → " + _vm._s(_vm.lang.U0042) + "\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyActive"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1037))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyActive),
      expression: "surveyData.SurveyActive"
    }],
    attrs: {
      "type": "checkbox",
      "id": "inputSurveyActive"
    },
    domProps: {
      "value": _vm.surveyData.SurveyActive,
      "checked": Array.isArray(_vm.surveyData.SurveyActive) ? _vm._i(_vm.surveyData.SurveyActive, _vm.surveyData.SurveyActive) > -1 : (_vm.surveyData.SurveyActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.surveyData.SurveyActive,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyVisibility",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyVisibility",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyVisibility"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1001))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyVisibility",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyVisibility"
    }
  }, [_c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "tab-content col-xs-12"
  }, [_c('div', {
    staticClass: "tab-pane tab-content-visibility active in",
    attrs: {
      "id": "visibilitySettingsTabContent"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "black",
      "padding-top": "15px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.currentVisibilitySettings.headerText) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('a', {
    staticClass: "btn btn-default",
    staticStyle: {
      "margin": "0 0 2px 0"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleAllVisibilityGroups()
      }
    }
  }, [(
    _vm.currentVisibilitySettings.selectedGroups.length ==
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("check_box")]) : (
    _vm.currentVisibilitySettings.selectedGroups.length ==
    0
  ) ? _c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("check_box_outline_blank")]) : _c('i', {
    staticClass: "material-icons md-24 text-primary"
  }, [_vm._v("indeterminate_check_box")]), _vm._v(" "), (
    _vm.currentVisibilitySettings.selectedGroups.length !=
    Object.keys(_vm.surveyGroupList).length
  ) ? _c('span', [_vm._v(_vm._s(_vm.lang.U1032))]) : _c('span', [_vm._v(_vm._s(_vm.lang.U1033))])])]), _vm._v(" "), _c('div', {
    staticClass: "table-content-visibility"
  }, [_c('table', {
    staticClass: "table table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('tbody', _vm._l((_vm.surveyGroupList), function(group, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "padding": "4px",
        "width": "20%"
      }
    }, [_c('div', {
      staticClass: "checkbox",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (
          _vm.currentVisibilitySettings.selectedGroups
        ),
        expression: "\n                                      currentVisibilitySettings.selectedGroups\n                                    "
      }],
      attrs: {
        "type": "checkbox",
        "id": 'cb_visibilitygroups_' + key
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(
          _vm.currentVisibilitySettings.selectedGroups
        ) ? _vm._i(
          _vm.currentVisibilitySettings.selectedGroups, key) > -1 : (
          _vm.currentVisibilitySettings.selectedGroups
        )
      },
      on: {
        "change": function($event) {
          var $$a =
            _vm.currentVisibilitySettings.selectedGroups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.currentVisibilitySettings, "selectedGroups", $$c)
          }
        }
      }
    }), _vm._v(" "), _vm._m(1, true)])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "16px",
        "padding": "6px",
        "width": "80%"
      }
    }, [_c('label', {
      staticClass: "text-black nopadding",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "role": "button",
        "for": 'cb_visibilitygroups_' + key
      }
    }, [_vm._v(_vm._s(group))])])])
  }), 0)])])])])]), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyLocalization",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyLocalization",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyLocalization"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1017))])])]) : _vm._e(), _vm._v(" "), (
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyTranslationLocales_Read'
    )
  ) ? _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyLocalization",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyLocalization"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguage"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1018))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguage",
      "placeholder": _vm.lang.U1067,
      "allowClear": true
    },
    on: {
      "change": function($event) {
        _vm.getLocales(), (_vm.newSurveyLanguageLocale = null)
      }
    },
    model: {
      value: (_vm.newSurveyLanguage),
      callback: function($$v) {
        _vm.newSurveyLanguage = $$v
      },
      expression: "newSurveyLanguage"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.languageList), function(language, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v("\n                            " + _vm._s(language) + "\n                          ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputNewLanguageLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1059))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "inputNewLanguageLocale",
      "placeholder": _vm.lang.U1068,
      "allowClear": true,
      "disabled": !_vm.newSurveyLanguage ||
        _vm.languageLocaleList.length < 1
    },
    model: {
      value: (_vm.newSurveyLanguageLocale),
      callback: function($$v) {
        _vm.newSurveyLanguageLocale = $$v
      },
      expression: "newSurveyLanguageLocale"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.languageLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.CountryCode
      }
    }, [_vm._v("\n                            " + _vm._s(locale.CountryName) + "\n                          ")])
  })], 2)], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "id": "addNewSurveyLanguage",
      "type": "button",
      "disabled": !_vm.newSurveyLanguageLocale
    },
    on: {
      "click": function($event) {
        return _vm.addNewSurveyLanguage()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.lang.U1019) + "\n                      ")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-hover",
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1020) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1069) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.U1021) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.surveyData.SurveySelectedLanguages), function(lang, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v("\n                          " + _vm._s(_vm.getLocaleString(
      lang.LanguageCode,
      lang.CountryCode
    )) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('div', {
      staticClass: "radio",
      staticStyle: {
        "margin": "0px"
      }
    }, [_c('label', {
      staticStyle: {
        "margin-top": "9px"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": "rd_defaultRepLanguage",
        "id": 'rd_defaultRepLanguage_' + key
      },
      domProps: {
        "value": key,
        "checked": lang.IsDefault
      },
      on: {
        "change": function($event) {
          return _vm.setDefaultSurveyLanguage(key)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "check"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticStyle: {
        "float": "none"
      }
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "padding": "0px",
        "margin": "7px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedLanguage(
            lang.LanguageCode,
            lang.CountryCode
          )
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("clear")])])])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyAttachment",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyAttachment",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyAttachment"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1022))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyAttachment",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyAttachment"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputAttachmentName"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1023))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      ),
      expression: "\n                          surveyData.SurveyAttachments[0].DownloadDescription\n                        "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputAttachmentName"
    },
    domProps: {
      "value": (
        _vm.surveyData.SurveyAttachments[0].DownloadDescription
      )
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData.SurveyAttachments[0], "DownloadDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyAttachmentFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1024))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyAttachmentFile",
      "type": "file",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyAttachmentFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(
    !_vm.surveyData.SurveyAttachments[0].DownloadFileName
  ) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1025))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyAttachments[0].DownloadFileName))]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(
          _vm.surveyData.SurveyAttachments[0].DownloadId
        )
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyAttachments[0].DownloadId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyAttachmentFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "button",
      "id": "headingEditSurveyOthers",
      "data-toggle": "collapse",
      "data-parent": "#accordionEditSurvey",
      "href": "#collapseEditSurveyOthers",
      "aria-expanded": "false",
      "aria-controls": "collapseEditSurveyOthers"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed"
  }, [_vm._v(_vm._s(_vm.lang.U1026))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseEditSurveyOthers",
      "role": "tabpanel",
      "aria-labelledby": "headingEditSurveyOthers"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group form-group-files"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputSurveyLogoFile"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1027))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "inputSurveyLogoFile",
      "type": "file",
      "accept": ".jpg, .jpeg, .png, .bmp",
      "title": _vm.lang.U1034
    },
    on: {
      "change": _vm.onSurveyLogoFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(!_vm.surveyData.SurveyLogoFileName) ? _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1028))]) : _c('label', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_vm._v(_vm._s(_vm.surveyData.SurveyLogoFileName))]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "id": "showSurveyLogoButton",
      "title": _vm.lang.U1035,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.globals.downloadFile(_vm.surveyData.SurveyLogoId)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("file_download")])])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button",
      "title": _vm.lang.U1036,
      "disabled": !_vm.surveyData.SurveyLogoId
    },
    on: {
      "click": function($event) {
        return _vm.removeSurveyLogoFile()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("clear")])])])]), _vm._v(" "), (_vm.surveyData.SurveyLogoId) ? _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputSurveyLogoFile",
      "delay": _vm.globals.tooltipDelay,
      "placement": "left"
    }
  }, [_c('img', {
    attrs: {
      "src": '/api/Download/' + _vm.surveyData.SurveyLogoId,
      "height": "200"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "inputMinimumAttachments"
    }
  }, [_vm._v(_vm._s(_vm.lang.U1029))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyMinimumAttachments),
      expression: "surveyData.SurveyMinimumAttachments"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "inputMinimumAttachments",
      "min": "0",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": (_vm.surveyData.SurveyMinimumAttachments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.surveyData, "SurveyMinimumAttachments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox col-md-3"
  }, [_c('label', {
    staticClass: "pull-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.surveyData.SurveyShowAttachmentsPage),
      expression: "surveyData.SurveyShowAttachmentsPage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.surveyData.SurveyShowAttachmentsPage) ? _vm._i(_vm.surveyData.SurveyShowAttachmentsPage, null) > -1 : (_vm.surveyData.SurveyShowAttachmentsPage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.surveyData.SurveyShowAttachmentsPage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.surveyData, "SurveyShowAttachmentsPage", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(4), _vm._v("\n                        " + _vm._s(_vm.lang.U1074) + "\n                      ")])])])])])])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.U0021))])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0022) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "id": "survey-management-edit-modal-save-button",
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_Surveys_Update') &&
        !_vm.dialogModeAdd
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editSurveyDialog')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.U0023) + "\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn input-group-sm"
  }, [_c('button', {
    staticClass: "btn btn-fab btn-fab-mini",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("attach_file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dcc8756","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyManagement/SurveyManagementEditModal.vue
// module id = 1704
// module chunks = 1